import * as React from "react";

const SvgIcnClose = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M15.595 9.216L12.81 12l2.784 2.784a.573.573 0 11-.811.811L12 12.81l-2.784 2.784a.573.573 0 11-.811-.811L11.19 12 8.405 9.216a.573.573 0 11.811-.811L12 11.19l2.784-2.784a.573.573 0 01.811.811z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnClose;
